export const STORAGE_KEY = "appointmentId";
